<template>
  <div>
    <div class="ba-grid ba-gp-08">
      <div class="ba-flex ba-gp-08 ba-w-100 ba-ai-center ba-jc-fe" style="height: 34px;">
        <div class="dropdown-container"
          v-if="filters_advanced.restrict_area || filters_advanced.permission">
          <button type="button" class="ba-btn ba-red ba-md"
            @click.prevent="filters.search = ''; filters_advanced.restrict_area = ''; filters_advanced.permission = ''; reload()">
            <builderall-icon code='funnel'></builderall-icon>
            {{ $t('ct-clear-filter') }}
          </button>
        </div>
        <div class="dropdown-container" style="min-width:150px">
          <button type="button"
            class="btn btn-filter dropdown-toggle d-inline-flex align-items-center justify-content-start"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="min-width:150px">
            {{
              filters_advanced.restrict_area
                ? this.$cutLongString(restrictAreas.find(
                  restrict =>
                    restrict.id === filters_advanced.restrict_area
                ).name, 15)
                : $t("ct-members-link-area")
            }}
            <builderall-icon code='5da4' class="sort-icon"></builderall-icon>
          </button>
          <div class="dropdown-menu centered">
            <a href="#" class="dropdown-item" v-for="(area, index) in restrictAreas" :key="index"
              @click.prevent="filters_advanced.permission = (!filters_advanced.permission ? 'released' : filters_advanced.permission); changeAdvancedFilter('restrict_area', area.id)">
              {{ area.name }}</a>
          </div>
        </div>

        <div class="dropdown-container">
          <button type="button"
            class="btn btn-filter dropdown-toggle d-inline-flex align-items-center justify-content-start"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{
              filters_advanced.permission
                ? $t(`ct-${filters_advanced.permission}`)
                : $t("ct-members-permission-type")
            }}
            <builderall-icon code='5da4' class="sort-icon"></builderall-icon>
          </button>
          <div class="dropdown-menu centered">
            <a href="#" class="dropdown-item" @click.prevent="
              changeAdvancedFilter('permission', 'released')
              ">
              {{ $t("ct-released") }}
            </a>
            <a href="#" class="dropdown-item" @click.prevent="
              changeAdvancedFilter('permission', 'blocked')
              ">
              {{ $t("ct-blocked") }}
            </a>
          </div>
        </div>

        <div class="dropdown-container" style="min-width:150px">
          <button type="button"
            class="btn btn-filter dropdown-toggle d-inline-flex align-items-center justify-content-start"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="min-width:150px">
            {{ filters.name }}
            <builderall-icon code='5da4' class="sort-icon"></builderall-icon>
          </button>
          <div class="dropdown-menu centered">
            <a href="#" class="dropdown-item" @click.prevent="changeFilter('alphabetical', 'A-Z')">A - Z</a>
            <a href="#" class="dropdown-item" @click.prevent="changeFilter('alphabetical', 'Z-A')">Z - A</a>
            <a href="#" class="dropdown-item" @click.prevent="changeFilter('creation', 'ascending')">{{
              $t("ct-creation") }} {{ $t("ct-ascending") }}</a>
            <a href="#" class="dropdown-item" @click.prevent="changeFilter('creation', 'descending')">{{
              $t("ct-creation") }} {{ $t("ct-descending") }}</a>
          </div>
        </div>

        <div class='ba-box-search-input ba-h-100' style="display: flex;">
          <input type='search' class='ba-input ba-sm' :placeholder="$t('ct-search')" v-model="filters.search"
            @keyup="changeSearch" @input="isTyping = true" ref="inputSearch" />
          <button class='ba-button' @click.prevent="">
            <builderall-icon code='search' />
          </button>
        </div>

        <button class='ba-btn ba-md ba-blue' @click.prevent="addNewUser">
          <builderall-icon code='2780'></builderall-icon>
          {{ $t('ct-members-add-new') }}
        </button>

        <!-- <div class="box-filter mt-2 mt-0-sm type-search">
          <form class="d-flex align-items-center my-0" action="#">
            <input class="form-control mr-2" type="text" :placeholder="$t('ct-search')" :aria-label="$t('ct-search')"
              v-model="filters.search" @keyup="changeSearch" @input="isTyping = true" ref="inputSearch" />
            <button class="btn btn-search btn-small" type="submit" @click.prevent="">
              <font-awesome-icon icon="search" />
            </button>
            <button class="btn btn-clear btn-small" type="reset" @click.prevent="
              filters.search = '';
            changeSearch();
            reload();
            ">
              <font-awesome-icon icon="times-circle" />
            </button>
          </form>
        </div> -->
      </div>
      <div class="ba-flex ba-w-100 ba-jc-sb ba-ai-center">
        <div>
          <div class="ba-flex ba-ai-center ba-gp-06" v-if="selectUsers.total > 0">
            <span class="ba-text-14 ba-montserrat-700 ba-text-capitalize">{{ $t('ct-selected-users-edit') }} ({{ selectUsers.total }})</span>
            <!-- <a href="#" class="mx-2" @click.prevent="clearSelect()">{{ $t('ct-selected-users-clear') }}</a> -->
            <button type="button" class="ba-btn ba-btn-normal ba-sm ba-rounded" @click.prevent="editManyMembers">
              <builderall-icon code='edit' />
            </button>
            <button type="button" class="ba-btn ba-btn-trash ba-sm ba-rounded" @click.prevent="deleteManyMembers">
              <builderall-icon code='trash' />
            </button>
            <button @click="exportStudents()" class="export-students-btn">{{ $t('ct-export-students') }}</button>
          </div>
        </div>
        <div class="ba-flex ba-ai-center ba-gp-06" v-if="selectUsers.total > 0">
          <span class="ba-text-14 ba-montserrat-700 ba-text-capitalize">{{ $t('ct-selected-users-edit') }} ({{ selectUsers.total }})</span>
          <!-- <a href="#" class="mx-2" @click.prevent="clearSelect()">{{ $t('ct-selected-users-clear') }}</a> -->
          <button type="button" class="ba-btn ba-btn-normal ba-sm ba-rounded"  @click.prevent="editManyMembers">
            <builderall-icon code='edit' />
          </button>
          <button type="button" class="ba-btn ba-btn-trash ba-sm ba-rounded" @click.prevent="deleteManyMembers">
            <builderall-icon code='trash' />
          </button>
        </div>
      </div>
    </div>

    <div class="ba-grid ba-mg-y-1 ba-gp-08" v-if="!isLoading">
      <div class="ba-card ba-no-shadow ba-w-100" style="background-color: #eff2f8;" v-if="users_filtered">
        <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
          <div class="ba-form-check"
            v-tooltip.top="{ content: `${$t('members-select-all')}`, class: 'tooltip-custom' }">
            <input type="checkbox" ref="select-all-members" id="select-members-all"
              :checked="selectUsers.type === 'all'" @change.prevent="selectUsersAll">
          </div>
          <span class="ba-montserrat-600" style="width: 100px;">{{ $t("ct-member-name") }}</span>
          <span class="ba-montserrat-600" style="width: 150px;">{{ $t("ct-member-email") }}</span>
          <span class="ba-montserrat-600">{{ $t("ct-restrict-area") }}</span>
          <span style="width: 70px;"></span>
        </div>
      </div>
      <div class="ba-card ba-w-100 ba-no-shadow " v-if="users_filtered && users_filtered.length > 0"
        v-for="(user, index) in users_filtered" :key="index" style="min-height: 60px;">
        <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
          <div class="ba-form-check">
            <input v-show="selectUsers.type === 'all'" type="checkbox" checked
              @click.prevent="checkedSelectAll(user.email)">
            <input v-show="selectUsers.type !== 'all'" type="checkbox" :id="`selected-user-${index}`"
              :value="user.email" v-model="selectUsers.selectedUsers" @change="changeUnitary(user.email)">
          </div>
          <hr class="ba-hr-column" style="height: 30px;">
          <div class="ba-grid ba-gp-04" style="width: 100px; word-break: break-all;">
            <span class="ba-montserrat-600 ba-text-14">{{ user.name }}</span>
            <span class="ba-badge ba-green ba-text-14" v-if="user.access_by_office_id">{{ $t('ct-members-ba-user') }}</span>
          </div>
          <hr class="ba-hr-column" style="height: 30px;">
          <span class="ba-montserrat-600 ba-text-14" style="width: 150px;"> {{ user.email }} </span>
          <hr class="ba-hr-column" style="height: 30px;">
          <span class="ba-montserrat-600 ba-text-uppercase ba-text-14" v-if="user.restrict_permissions" style="width: 150px;">
            {{
              user.restrict_permissions
                .filter(
                  restrict_permission => restrict_permission.active
                )
                .map(
                  restrict_permission =>
                    restrict_permission.restrict_area &&
                    restrict_permission.restrict_area.name
                )
                .join(", ")
            }}
          </span>
          <hr class="ba-hr-column" style="height: 30px;">
          <div class="ba-flex ba-gp-06">
            <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="editUser(user)"
              ba-tooltip-position='top' :ba-tooltip-title="$t('ct-edit')">
              <builderall-icon code='edit' />
            </button>
            <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="openModal(user)"
              ba-tooltip-position='top' :ba-tooltip-title="$t('ct-remove')">
              <builderall-icon code='trash' />
            </button>
          </div>
        </div>
      </div>
      <div class="ba-w-100" v-if="users_filtered.length === 0 && filters.search.length > 0">
        <span>{{ $t("ct-members-list-is-empty-search") }}</span>
      </div>

      <div class="ba-w-100" v-if="users_filtered.length === 0 && filters.search.length === 0">
        <builderall-empty-image />
      </div>

      <div class="ba-w-100" v-if="pagination && pagination.total > pagination.per_page">
        <pagination-component :pagination="pagination" @paginate="paginationChange()" :offset="4"></pagination-component>
      </div>
    </div>
    <div v-else class="table-user-members-loading d-flex justify-content-center align-items-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- <div class="d-block p-0 row">
      <div class="col-12">
        <div class="table-user-members" v-if="!isLoading">
          <div class="table-user-members-header-row" v-if="users_filtered">
            <div class="table-users-members-col align-items-center">
              <div class="form-check p-0"
                v-tooltip.top="{ content: `${$t('members-select-all')}`, class: 'tooltip-custom' }">
                <input type="checkbox" ref="select-all-members" id="select-members-all"
                  :checked="selectUsers.type === 'all'" @change.prevent="selectUsersAll">
              </div>
            </div>
            <div class="table-users-members-col d-flex align-items-center">
              {{ $t("ct-member-name") }}
            </div>

            <div class="table-users-members-col">
              {{ $t("ct-member-email") }}
            </div>

            <div class="table-users-members-col">
              {{ $t("ct-restrict-areas") }}
            </div>

            <div class="table-users-members-col"></div>
          </div>

          <div class="table-user-members-row card" v-if="users_filtered && users_filtered.length > 0"
            v-for="(user, index) in users_filtered" :key="index">
            <div class="table-users-members-col align-items-center justify-content-left">

              <input v-show="selectUsers.type === 'all'" type="checkbox" checked
                @click.prevent="checkedSelectAll(user.email)">

              <input v-show="selectUsers.type !== 'all'" type="checkbox" :id="`selected-user-${index}`"
                :value="user.email" v-model="selectUsers.selectedUsers" @change="changeUnitary(user.email)">
            </div>
            <div class="table-users-members-col d-flex align-items-center justify-content-between">{{ user.name }}<span
                class="badge badge-info" v-if="user.access_by_office_id">{{ $t('ct-members-ba-user') }}</span>
            </div>

            <div class="table-users-members-col">
              {{ user.email }}
            </div>

            <div class="table-users-members-col" v-if="user.restrict_permissions">
              {{
                user.restrict_permissions
                  .filter(
                    restrict_permission => restrict_permission.active
                  )
                  .map(
                    restrict_permission =>
                      restrict_permission.restrict_area &&
                      restrict_permission.restrict_area.name
                  )
                  .join(", ")
              }}
            </div>
            <div class="table-users-members-col" v-else></div>

            <div class="table-users-members-col d-flex align-items-center justify-content-end">
              <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click.prevent="editUser(user)"
                ba-tooltip-position='top' :ba-tooltip-title="$t('ct-edit')">
                <builderall-icon code='edit' />
              </button>
              <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="openModal(user)"
                ba-tooltip-position='top' :ba-tooltip-title="$t('ct-remove')">
                <builderall-icon code='trash' />
              </button>

            </div>
          </div>

          <div class="table-user-members-row row my-2" v-if="
            users_filtered.length === 0 && filters.search.length > 0
          ">
            <div class="table-users-members-col col-12">
              {{ $t("ct-members-list-is-empty-search") }}
            </div>
          </div>

          <div class="table-user-members-row row my-2" v-if="
            users_filtered.length === 0 && filters.search.length === 0
          ">
            <div class="table-users-members-col is-empty-search col-12 text-center">{{
              $t("ct-members-list-is-empty")
              }}
            </div>
          </div>

          <div class="row" v-if="pagination && pagination.total > pagination.per_page">
            <nav class="col">
              <pagination-component :pagination="pagination" @paginate="paginationChange()"
                :offset="4"></pagination-component>
            </nav>
          </div>
        </div>
        <div v-else class="table-user-members-loading d-flex justify-content-center align-items-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div> -->

    <modal-delete-component :show="modalDelete.show" :values="modalDelete.config" @cancel="cancelModal()"
      @exclude="deleteUser"></modal-delete-component>

    <!--    <import-members-component ref="import-members" :website_id="website.encrypted_id"-->
    <!--                              :restrictAreas="restrictAreas" @reloadUsers="reloadUsers"></import-members-component>-->

    <!--    <export-members-component ref="export-members" :website_id="website.encrypted_id" :pagination="this.pagination"-->
    <!--                              :filters="{ ...filters, ...filters_advanced}"-->
    <!--                              :restrictAreas="restrictAreas"></export-members-component>-->

    <new-member-component ref="new-member" :website_id="website.encrypted_id" :restrictAreas="restrictAreas"
      @reloadUsers="reloadUsers"></new-member-component>

    <edit-member-component ref="edit-member" :website_id="website.encrypted_id" :restrictAreas="restrictAreas"
      @reloadUsers="reloadUsers" @editWebsiteUser="editUser(user)"
      @editWebsiteUserPassword="editWebsiteUserPassword"></edit-member-component>

    <edit-member-password ref="edit-member-password" :website_id="website.encrypted_id"></edit-member-password>

    <edit-many-members-component ref="edit-many-member" :website_id="website.encrypted_id"
      :restrictAreas="restrictAreas" @reloadUsers="reloadUsers"
      @clearSelect="clearSelect"></edit-many-members-component>

    <delete-many-members-component ref="delete-many-member" :website_id="website.encrypted_id"
      :restrictAreas="restrictAreas" @reloadUsers="reloadUsers"
      @clearSelect="clearSelect"></delete-many-members-component>

  </div>
</template>

<script>
import NavComponent from '../../layout/nav/Nav';
import BreadcrumbComponent from '../../components/Breadcrumb';
import PaginationComponent from '../../components/Pagination.vue';
import SiteSidebarComponent from '../../layout/site/SiteSidebar';
import ModalDeleteComponent from '../../components/ModalDelete';
// import ImportMembersComponent from './../MembersArea/Import.vue';
// import ExportMembersComponent from './../MembersArea/Export.vue';
import NewMemberComponent from './../MembersArea/NewMember.vue';
import EditMemberComponent from './../MembersArea/EditMember.vue';
import EditMemberPassword from './../MembersArea/UpdatePassword.vue';
import Errors from '../../../../js/base/Errors';
import AlertBoxComponent from '../../../commons/AlertBoxComponent.vue';

import {
  getAll as getAllWebsiteUsers,
  edit as editWebsiteUser,
  exclude as excludeWebsiteUser
} from '../../../../js/services/restrictArea/websiteUsers';
import { getAll as getAllRestrictArea } from '../../../../js/services/restrictArea/restrictArea';

import { debounce } from '../../../../js/base/Utils';

export default {
  name: 'Members',
  components: {
    NavComponent,
    BreadcrumbComponent,
    SiteSidebarComponent,
    ModalDeleteComponent,
    PaginationComponent,
    // ImportMembersComponent,
    // ExportMembersComponent,
    NewMemberComponent,
    EditMemberComponent,
    'edit-many-members-component': () => import('./../MembersArea/EditManyMembers.vue'),
    'delete-many-members-component': () => import('./../MembersArea/DeleteManyMembers.vue'),
    EditMemberPassword,
    AlertBoxComponent
  },
  data() {
    return {
      errors: new Errors(),
      isTyping: false,
      isLoading: false,
      selectUsers: {
        type: 'unitary', // unitary or all
        selectedUsers: [],
        total: 0
      },
      filters: {
        search: '',
        order: 'A-Z',
        name: this.$t('ct-alphabetical') + ' A - Z'
      },
      filters_advanced: {
        restrict_area: '',
        permission: ''
      },
      per_page: 1,
      pagination: {
        current_page: 1,
        last_page: 0,
        from: 0,
        path: 0,
        per_page: 25,
        to: '',
        total: ''
      },
      website: { id: '', encrypted_id: '' },
      page: {},
      users: false,
      users_filtered: [],
      user: {},
      restrictAreas: {},
      modalDelete: {
        show: false,
        config: ''
      }
    };
  },

  watch: {
    isTyping: function (value) {
      if (!value) {
        this.isLoading = true;
        if (this.isLoading) this.reloadUsers();
      }
    }
  },

  methods: {

    selectUsersAll() {
      this.selectUsers.type = this.selectUsers.type === 'all' ? 'unitary' : 'all';

      if (this.selectUsers.type === 'all')
        this.selectUsers.total = this.pagination.total;
      else
        this.selectUsers.total = this.selectUsers.selectedUsers.length;

      this.$refs['select-all-members'].checked = true;
    },

    checkedSelectAll(userEmail) {
      if (this.selectUsers.type === 'all') {
        this.selectUsers.type = 'unitary';
        this.$refs['select-all-members'].checked = false;
      }

      if (!this.selectUsers.selectedUsers.includes(userEmail))
        this.selectUsers.selectedUsers.push(userEmail)

      this.changeUnitary(userEmail);
    },

    clearSelect() {
      this.selectUsers = {
        type: 'unitary', // unitary or all
        selectedUsers: [],
        total: 0
      };
    },

    changeUnitary(userEmail, input = false) {
      this.selectUsers.total = this.selectUsers.selectedUsers.length;
    },

    async reload() {
      this.pagination.current_page = 0;
      this.reloadUsers();
    },

    changeSearch(forceReload = false) {
      this.filters.search = this.filters.search.trim();

      this.pagination.current_page = 0;
    },

    changeFilter(name, value) {
      this.filters.order = value;
      this.filters.name = this.$t(`ct-${name}`) + ' ' + value;
      this.setStorage();
      this.reload();
    },

    changeAdvancedFilter(name, value) {
      this.filters_advanced[name] = value;
      this.reload();
    },

    paginationChange() {
      this.reloadUsers();
    },

    setStorage() {
      try {
        let filters = { ...this.filters };
        filters.search = '';
        localStorage.setItem(
          'dashboard-filters-members-list',
          JSON.stringify(filters)
        );
      } catch (e) {
        console.warn(e);
      }
    },

    getStorage() {
      try {
        let filtersMembers = localStorage.getItem(
          'dashboard-filters-members-list'
        );
        let filters = JSON.parse(filtersMembers);
        this.filters.order = filters.order;

        this.changeFilter(
          this.filters.order === 'A-Z' || this.filters.order === 'Z-A'
            ? 'alphabetical'
            : 'creation',
          this.filters.order
        );
      } catch (e) {
        console.warn(e);
      }
    },

    editUser(user) {
      user.restrict_permissions_list = [];
      user.restrict_permissions_obj = [];
      this.user_permissions = [];

      this.restrictAreas.map(restrict => {
        let user_permission = {
          active: false,
          expire: null,
          has_expires_at: null
        };

        let permission = user.restrict_permissions.find(
          permission => +permission.restrict_area_id === +restrict.id
        );

        if (permission) {
          user_permission = { ...permission };

          if (permission.active && permission.expire === null)
            user.restrict_permissions_list.push(permission.restrict_area_id);
          else if (permission.expire !== null) {
            var dateExpire = new Date(permission.expire);
            var dateNow = new Date();

            dateExpire.setHours(0);
            dateExpire.setMinutes(0);
            dateExpire.setSeconds(0);
            dateExpire.setMilliseconds(0);

            dateNow.setHours(0);
            dateNow.setMinutes(0);
            dateNow.setSeconds(0);
            dateNow.setMilliseconds(0);

            user_permission.has_expires_at = true;

            function addZero(n) {
              return parseInt(n) > 9 ? '' + n : '0' + n;
            }

            user_permission.expire = `${[
              dateExpire.getFullYear(),
              addZero(dateExpire.getMonth() + 1),
              addZero(dateExpire.getDate())
            ].join('-')}`;

            if (dateNow <= dateExpire) {
              user.restrict_permissions_list.push(permission.restrict_area_id);

              user_permission.active = true;
            } else
              user_permission.active = false;
          }
        }
        user_permission.restrict_area = restrict;
        user.restrict_permissions_obj.push(user_permission);
      });

      this.user = Object.assign({}, this.user, user);
      this.$refs['edit-member'].setUser(this.user);
      this.$refs['edit-member'].open();
    },

    cancelModal() {
      this.modalDelete = {
        show: false,
        config: ''
      };

      this.user = {};
      this.$refs['edit-member'].close();
    },

    openModal(user) {
      this.modalDelete = {
        show: true,
        config: user
      };
    },

    deleteUser(user) {
      this.clearSelect();
      this.$loading.show();

      excludeWebsiteUser(user)
        .then(response => {
          if (response.data.success) {
            this.$snotify.success(this.$t('ct-success-true'), {
              position: 'centerTop'
            });

            this.users = this.users.filter(
              user_filter => user_filter.email !== user.email
            );
            this.reload();
            this.cancelModal();
          } else {
            if (response.data.validator)
              this.errors.record({ restrictArea: response.data.errors });
            else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });

              this.cancelModal();
            }
          }
        })
        .catch(error => {
          this.$snotify.success(this.$t('ct-success-false'), {
            position: 'centerTop'
          });

          this.cancelModal();
        })
        .finally(() => this.$loading.hide());
    },

    reloadUsers() {
      this.isLoading = true;

      getAllWebsiteUsers(
        this.$route.params.website_id,
        this.pagination.current_page,
        {
          search: this.filters.search,
          type:
            this.filters.order === 'A-Z' || this.filters.order === 'Z-A'
              ? 'alphabetical'
              : 'creation',
          order:
            this.filters.order === 'A-Z' || this.filters.order === 'ascending'
              ? 'asc'
              : 'desc',
          restrict_area: this.filters_advanced.restrict_area,
          permission: this.filters_advanced.permission
        }
      )
        .then(({ data }) => {
          if (data.success) {
            this.users = data.data;

            this.pagination = {
              current_page: data.current_page,
              last_page: data.last_page,
              from: data.from,
              path: data.path,
              per_page: data.per_page,
              to: data.to,
              total: data.total
            };

            this.users_filtered = this.users;
          }
        })
        .catch(error => {
        })
        .finally(() => (this.isLoading = false));
    },
    updateUser() {
      this.$loading.show();

      this.user.restrict_permissions_list = this.user.restrict_permissions_list.filter(Boolean);

      editWebsiteUser({ ...this.user, time_zone: this.$getTimeZone() })
        .then(response => {
          if (response.data.success) {
            this.$snotify.success(this.$t('ct-success-true'), {
              position: 'centerTop'
            });

            this.reloadUsers();
            this.cancelModal();
          } else {
            if (response.data.validator)
              this.errors.record({ restrictArea: response.data.errors });
            else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });

              this.cancelModal();
            }
          }
        })
        .catch(error => {
          console.error('error', error);
        })
        .finally(() => this.$loading.hide());
    },

    addNewUser() {
      this.$refs['new-member'].open();
    },

    importMembers() {
      this.$refs['import-members'].open();
    },

    exportStudents() {
      if (!this.selectUsers || this.selectUsers.total === 0) return;

      const headers = [
        this.$t('ct-member-name'),
        this.$t('ct-member-email'),
        this.$t('ct-restrict-area')
      ];

      const escapeCsv = (value) => `"${String(value || '').replace(/"/g, '""')}"`;

      const getRestrictAreas = (user) =>
        (user.restrict_permissions || [])
          .filter(rp => rp.active)
          .map(rp => rp.restrict_area.name)
          .filter(Boolean)
          .join(', ');

      const usersToExport = this.selectUsers.type === 'all'
        ? this.users_filtered
        : this.users_filtered.filter(user => this.selectUsers.selectedUsers.includes(user.email));

      const rows = [
        headers.join(','),
        ...usersToExport.map(user => {
          const values = [
            user.name,
            user.email,
            getRestrictAreas(user)
          ].map(escapeCsv);

          return values.join(',');
        })
      ];

      const csvContent = '\uFEFF' + rows.join('\n');

      const blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;'
      });

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'members.csv';
      link.click();

      URL.revokeObjectURL(url);
    },

    editManyMembers() {
      this.$refs['edit-many-member'].setUsers(this.selectUsers);
      this.$refs['edit-many-member'].open();
    },

    deleteManyMembers() {
      this.$refs['delete-many-member'].setUsers(this.selectUsers);
      this.$refs['delete-many-member'].open();
    },

    editWebsiteUserPassword(user) {
      this.$refs['edit-member'].close();
      this.$refs['edit-member-password'].setUser(user);
      this.$refs['edit-member-password'].open();
    },
  },

  created() {
    this.website.encrypted_id = this.$route.params.website_id;

    this.$loading.show();

    let filtersMembers = localStorage.getItem('dashboard-filters-members-list');

    if (filtersMembers && filtersMembers !== 'null')
      this.getStorage();

    this.reloadUsers();

    getAllRestrictArea(this.$route.params.website_id)
      .then(response => {
        if (response.data.success && response.data.data.length > 0)
          this.restrictAreas = response.data.data;
      })
      .catch(error => {
        console.error('error', error);
      })
      .finally(data => {
        this.$loading.hide();
      });
  },
  mounted() {
    var vm = this;
    this.$refs.inputSearch.addEventListener(
      'keyup',
      debounce(() => {
        vm.isTyping = false;
      }, 500)
    );
  }
};
</script>

<style>
.border-modal-members {
  background: #ffffff;
  border: 1px solid #e3e8eb;
  border-radius: 5px;
}

.container-user {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  width: 100%;
  font-family: Lato, Helvetica Neue, Helvetica, Arial, sans-serif;
}
</style>
<style lang="scss" scoped>
.title {
  font-family: "Muli", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 25px;
}

.title-label {
  font-size: 16px;
  color: #434343;
  margin: 10px 0;
  display: inline-block;
}

.table-user-members,
.table-user-members-loading {
  font-family: "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin: 20px 0;
}

.table-user-members-loading {
  min-height: 200px;
  color: #434343;
}

.container-user {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  width: 100%;
  font-size: 14px;

  .subtitle {
    text-align: left;
    font-family: "Muli", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    color: #434343;
  }

  .card-label {
    span {
      flex: 1;
      color: #434343;
      font-size: 15px;
      font-weight: bold;
      margin: 0 20px;
    }
  }

  .card-fields {
    p {
      flex: 1;
    }
  }

  .card-permissions {
    background: #ffffff;
    border: 1px solid #e3e8eb;
    border-radius: 5px;
    padding: 20px;
    margin: 15px 0;

    p {
      margin-bottom: 0;
    }
  }
}

.table-user-members-row {
  height: auto;
  min-height: 70px;
  margin: 15px 0;
  padding: 16px 20px;
  color: #8c8c8c;

  .btn {
    padding: 0 7px;
    font-size: 18px;

    &.edit {
      color: #0080fc;
    }

    &.danger {
      color: #fa4b57;
    }
  }
}

.table-user-members-header-row {
  margin: 5px 0;
  padding: 0 20px;
  font-weight: bold;
  color: #434343;
}

.table-user-members-header-row>div:first-child:not(.is-empty-search) {
  max-width: 40px;
}

.table-user-members-row .table-users-members-col:first-child:not(.is-empty-search) {
  max-width: 40px;
  min-width: 40px;
}

.table-user-members-row,
.table-user-members-header-row {
  display: flex;
  flex-direction: row;

  >div:not(.is-empty-search) {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: start;

    max-width: 22.5%;
    padding: 0 5px;
    word-break: break-word;

    &:nth-child(2) {
      max-width: 30%;
      min-width: 30%;
    }

    &:last-child:not(.is-empty-search) {
      justify-content: end;
      max-width: 20%;
      min-width: 20%;
    }
  }
}

.export-students-btn {
  background: transparent;
  border: none;
  color: #0072E1;
  font-weight: 700;
  font-size: 14px;
  outline: none;
}

.header-container-title {
  display: flex;
  justify-content: space-between;

  .header-container-title-actions {
    display: none;
    margin-bottom: .5rem;
  }
}

.header-container-select-items {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    font-family: "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: bold;
    color: #434343;
    //max-width: 120px;
  }
}

@media (min-width: 992px) and (max-width: 1400px) {

  .header-container-title,
  .header-container-actions {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .header-container-title {
    .header-container-title-actions {
      display: flex;

      .header-container-select-items {
        span {
          max-width: none;
        }
      }
    }
  }

  .header-container-actions {

    .header-container-select-items,
    .header-container-clear-filters {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/MembersArea/MembersList.vue